import { BotSendError } from "../../utils/AlertBot";
import { apiEscuelaObtenerClima } from "../API";
import { _APP_DATA } from "../AppData";
import { RequestData } from "../utils/RequestData";

export interface IWeather {
    id: number;
    date: Date;
    description: string;
    icon: string;
    iconV2: string;
    main: string;
    day: number;
    min: number;
    max: number;
}

export function _SvEscuelaObtenerClima(callback: (weather: Array<IWeather>) => void): void {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder
    }

    new RequestData<any>(apiEscuelaObtenerClima)
        .Params(params)
        .Completion((dataResponse, error) => {

            if (error != null || !dataResponse || !dataResponse.daily) {
                console.warn(error, dataResponse);
                BotSendError(error ? error : new Error("error"), JSON.stringify(dataResponse))
                if (callback) callback(null);
                return
            }

            let daily = <Array<any>>dataResponse.daily;
            let result: IWeather[] = [];

            daily.forEach((item, i) => {
                let value: IWeather = {
                    id: (i + 1),
                    date: new Date(),
                    description: item.weather[0].description,
                    main: item.weather[0].main,
                    icon: item.weather[0].icon,
                    iconV2: item.weather[0].iconV2,

                    day: item.temp.day,
                    min: item.temp.min,
                    max: item.temp.max
                };

                value.date.setDate(value.date.getDate() + i)

                result.push(value);
            });

            if (callback) callback(result);
        }).Get();
}